import React, { useState, useContext } from "react";
import "../../styles/MainHeader.scss";
import SearchHeaders from "../SearchHeaders";
import { Link, Outlet } from "react-router-dom";
import OutsideClickHandler from "../../common/OutsideClickHandler";
import { useNavigate } from "react-router-dom";
import { MyAccountContext } from "../../App";
import Logo from "../../assets/Icons/brighter-portal-logo.svg";

export default function MainHeader() {
  const [showAdminDropdown, setShowAdminDropdown] = useState(false);
  const navigateTo = useNavigate();
  const { grantedRoles = [] } = useContext(MyAccountContext) || {};
  const hasPracticeRole = grantedRoles.includes("ROLE_PRACTICE");
  const isManager = grantedRoles.includes("ROLE_MANAGER");

  const token = localStorage.getItem("auth-key");

  const logoClick = () => {
    if (token) {
      navigateTo("/dashboard");
    } else {
      navigateTo("/home");
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    document.location = "/#/login";
    window.location.reload();
  };

  return (
    <div>
      <div role="navigation" id="main-navbar">
        <header className="navbar navbar-static-top bottom-margin-zero">
          <div className="container-fluid clearfix container-block">
            <a className="navbar-brand pull-left" onClick={() => logoClick()}>
              <img alt="Brighter - when you smile we smile." src={Logo} />
            </a>

            {token && (
              <div className="portal-nav pull-right clearfix">
                {!hasPracticeRole && <SearchHeaders />}
                <div className="nav-menu pull-right text-uppercase">
                  {isManager ? (
                    <>
                      <Link to="/account-settings/logininformation">
                        My Account
                      </Link>{" "}
                      <span style={{ color: "#b4d4e6" }}>|</span>
                      <Link to="#" onClick={handleLogout}>
                        Log Out
                      </Link>
                    </>
                  ) : hasPracticeRole ? (
                    <>
                      <Link to="/contactus">Contact Us</Link>{" "}
                      <span style={{ color: "#b4d4e6" }}>|</span>
                      <Link to="/account-settings/logininformation">
                        My Account
                      </Link>{" "}
                      <span style={{ color: "#b4d4e6" }}>|</span>
                      <Link to="#" onClick={handleLogout}>
                        Log Out
                      </Link>
                    </>
                  ) : (
                    <>
                      <Link to="/account-settings/logininformation">
                        My Account
                      </Link>{" "}
                      <span style={{ color: "#b4d4e6" }}>|</span>
                      <OutsideClickHandler
                        onClickOutside={() => {
                          if (showAdminDropdown) {
                            setShowAdminDropdown(false);
                          }
                        }}
                      >
                        <Link
                          className="menu"
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowAdminDropdown(true);
                          }}
                        >
                          Admin
                        </Link>
                        <span style={{ color: "#b4d4e6" }}>|</span>
                        {showAdminDropdown && (
                          <div className="adminDropdown">
                            <ul className="adminDropdownList">
                              <li>
                                <Link
                                  to="/addProviders"
                                  onClick={() => {
                                    // e.preventDefault();
                                    setShowAdminDropdown(false);
                                  }}
                                >
                                  Add Provider
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/addPractice"
                                  onClick={() => {
                                    // e.preventDefault();
                                    setShowAdminDropdown(false);
                                  }}
                                >
                                  Add Practice
                                </Link>
                              </li>
                              <li className="lastItem">
                                <Link
                                  to="/user-management"
                                  onClick={() => {
                                    // e.preventDefault();
                                    setShowAdminDropdown(false);
                                  }}
                                >
                                  User Management
                                </Link>
                              </li>
                            </ul>
                          </div>
                        )}
                      </OutsideClickHandler>
                      <Link to="#" onClick={handleLogout}>
                        Log Out
                      </Link>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </header>
      </div>
      <Outlet />
    </div>
  );
}
